module.exports = __webpack_public_path__ + "static/media/gallery5.5fc854d1.webp";